import React, {useEffect, useState} from "react";
import {Table, TableData} from "peggirkit";
import {DayReport} from "@/data/entities/dayReport";
import {dayReportSummaryColumns} from "@widgets/reports/dayReport/summary/DayReportSummaryColumns";

type Props = {
    dayReport: DayReport,
};

const DayReportTable = ({dayReport}: Props) => {
    const [data, setData] = useState<TableData<DayReport>[]>([dayReport]);

    // Keep the table in sync when the report is refetched or another day is picked
    useEffect(() => setData([dayReport]), [dayReport]);

    return (
        <Table<DayReport>
            columns={
                dayReportSummaryColumns.map((col) => ({
                    ...col,
                    label: {
                        displayName: col.header,
                    },
                    align: col.alignRight ? "right" : "left",
                    formatter: (x, y) => col.displayValue(y),
                    primary: true,
                }))
            }
            data={data}
            setData={setData}
        />
    );
};

export default DayReportTable;